<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemPolice.libelle}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busyGet,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Filiale :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Filiale" autocomplete="off"
                            [(ngModel)]="itemPolice.filiale_libelle" name="filiale_libelle" autocomplete="off"
                            type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Garant :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Garant" autocomplete="off"
                            [(ngModel)]="itemPolice.garant_libelle" name="garant_libelle" autocomplete="off"
                            type="text" />
                    </div>


                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Code:
                            
                        </label>
                        <input disabled class="form-control custom-input" [disabled]="itemPolice.id" placeholder="Code"
                            autocomplete="off" [(ngModel)]="itemPolice.code" name="code" autocomplete="off"
                            type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Codification:
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Codification" autocomplete="off"
                            [(ngModel)]="itemPolice.codification" name="codification" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Libellé :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                            [(ngModel)]="itemPolice.libelle" name="libelle" autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Date éffet :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Date effet" autocomplete="off"
                            [(ngModel)]="itemPolice.date_effet" name="date_effet" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Date échéance :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Date échéance" autocomplete="off"
                            [(ngModel)]="itemPolice.date_echeance" name="date_echeance" autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Plafond :
                            
                        </label>
                        <input disabled mask="separator" class="form-control custom-input" placeholder="Plafond"
                            autocomplete="off" [(ngModel)]="itemPolice.plafond" name="plafond" autocomplete="off"
                            type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission sinistre :
                            
                        </label>
                        <input disabled mask="separator" class="form-control custom-input"
                            placeholder="Taux commission sinistre" autocomplete="off"
                            [(ngModel)]="itemPolice.taux_commission_sinistre" name="taux_commission_sinistre"
                            autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission sinistre :
                            
                        </label>
                        <input disabled mask="separator" class="form-control custom-input"
                            placeholder="Forfait commission sinsitre" autocomplete="off"
                            [(ngModel)]="itemPolice.forfait_commission_sinistre" name="forfait_commission_sinistre"
                            autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission prime :
                            
                        </label>
                        <input disabled mask="separator" class="form-control custom-input"
                            placeholder="Taux commission prime" autocomplete="off"
                            [(ngModel)]="itemPolice.taux_commission_prime" name="taux_commission_prime"
                            autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission prime :
                            
                        </label>
                        <input disabled mask="separator" class="form-control custom-input"
                            placeholder="Forfait commission prime" autocomplete="off"
                            [(ngModel)]="itemPolice.forfait_commission_prime" name="forfait_commission_prime"
                            autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Catégorie :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Catégorie" autocomplete="off"
                            [(ngModel)]="itemPolice.categorie_police_libelle" name="categorie_police_libelle"
                            autocomplete="off" type="text" />
                    </div>


                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Souscripteur :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="souscripteur" autocomplete="off"
                            [(ngModel)]="itemPolice.souscripteur_libelle" name="souscripteur_libelle"
                            type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Type remboursement :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Type remboursement"
                            autocomplete="off" [(ngModel)]="itemPolice.type_remboursement_libelle"
                            name="type_remboursement_libelle" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Courtier :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Courtier" autocomplete="off"
                            [(ngModel)]="itemPolice.courtier_libelle" name="courtier_libelle" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Commercial :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Commercial" autocomplete="off"
                            [(ngModel)]="itemPolice.commerciale" name="commerciale" autocomplete="off"
                            type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Délai de carence (jours) :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Délai de carence"
                            autocomplete="off" [(ngModel)]="itemPolice.delai_carence" name="delai_carence"
                            autocomplete="off" type="text" mask="separator">
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Seuil alerte consommation (%) :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Seuil alerte conso"
                            autocomplete="off" [(ngModel)]="itemPolice.seuil_alerte_conso" name="seuil_alerte_conso"
                            autocomplete="off" type="text" />
                    </div>



                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Seuil suspension tiers payant (%) :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Seuil suspension tp"
                            autocomplete="off" [(ngModel)]="itemPolice.seuil_suspension_tiers_payant"
                            name="seuil_suspension_tiers_payant" autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>A qui rembourser? :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Assuré remboursement"
                            autocomplete="off" [(ngModel)]="itemPolice.assure_remboursement" name="assure_remboursement"
                            autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Mode tarification :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Mode tarification"
                            autocomplete="off" [(ngModel)]="itemPolice.mode_tarification_libelle"
                            name="mode_tarification_libelle" autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Mode reconduction :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Mode reconduction"
                            autocomplete="off" [(ngModel)]="itemPolice.mode_reconduction_libelle"
                            name="mode_reconduction_libelle" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Mode fractionnement :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Mode fractionnement"
                            autocomplete="off" [(ngModel)]="itemPolice.mode_fractionnement_libelle" name="mode_fractionnement_libelle"
                            autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label [ngClass]="{'isSelectedItem':itemPolice.reseau_de_soin_id}" (click)="openModalPrestataireReseau()">Réseau de soin :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Réseau de soin"
                            autocomplete="off" [(ngModel)]="itemPolice.reseau_de_soin_libelle" name="reseau_de_soin_libelle"
                            autocomplete="off" type="text" />
                    </div>



                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Statut :
                            
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Statut" autocomplete="off"
                            [(ngModel)]="itemPolice.statut_police_libelle" name="statut_police_libelle" autocomplete="off"
                            type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input disabled [(ngModel)]="itemPolice.is_prorata_prime" id="is_prorata_prime"
                            name="is_prorata_prime" autocomplete="off" type="checkbox" />
                        <label for="is_prorata_prime">Prorata prime?
                        </label>
                    </div>


                </div>
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">


        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>